export const EVENTS_COLLECTION = "events";
export const USERS = "users";
export const WEBSITE_USERS = "website-artists";
export const locale = "en-us";

export function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
}

export const BRANDS_LOGO = [
  {
    image: require("../pages/ContactUs/static/images/brands/moodIndigo.jpg"),
    key: "MoodIndigo - IIT Bombay",
  },
  {
    image: require("../pages/ContactUs/static/images/brands/effe.png"),
    key: "Effervescence - IIIT Allahabad",
  },
  {
    image: require("../pages/ContactUs/static/images/brands/saptak.jpg"),
    key: "Saptak - NIT Patna",
  },
  {
    image: require("../pages/ContactUs/static/images/brands/nitcalicut.png"),
    key: "NIT Calicut",
  },
  {
    image: require("../pages/ContactUs/static/images/brands/nitsilchar.png"),
    key: "NIT Silchar",
  },
  {
    image: require("../pages/ContactUs/static/images/brands/iitpallakad.svg"),
    key: "IIT Palakkad",
  },
];

export const GPLAY_DOWNLOAD_LINK =
  "https://play.google.com/store/apps/details?id=com.liveombre.ombre";
export const APPLE_STORE_DOWNLOAD_LINK =
  "https://apps.apple.com/us/app/ombr%C3%A9-live-streaming-music/id1530673435";



// WEBPACK FOOTER //
// ./src/utils/consts.js